import { render } from "./modalMedia.vue?vue&type=template&id=e2ee09de&scoped=true&ts=true"
import script from "./modalMedia.vue?vue&type=script&lang=ts"
export * from "./modalMedia.vue?vue&type=script&lang=ts"

import "./modalMedia.vue?vue&type=style&index=0&id=e2ee09de&scoped=true&lang=css"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2ee09de"]])

export default __exports__